<template lang="pug">
    div
      h2 EOI 打分表
      h5 「最低65分移民门槛」
      .progress
        .progress-bar.progress-bar-animated(role="progressbar" :style="'width:' + current_progress + '%'" :aria-valuenow="current_progress" aria-valuemin="0" aria-valuemax="100")
      section(v-for="question, key in questions" :key="key" v-if="current_step == key")
        Question(v-model="questions[key]" :index="key" @next="updateStep" :inline='false')
      section(v-if="current_step + 1 > questions.length")
        .final-score 最终得分：
          span.score {{current_score}}
          span 分
        .message(v-if="current_score >= min" v-html="message")
        .error(v-else v-html="error")
      .bottom.row
        .col.text-left
          button(@click.prevent="current_step -= 1" v-if="current_step > 0 && current_step < questions.length") 上一步
          button.reset(@click="reset" v-if="current_step + 1 > questions.length") 重新填写
        .col.text-right
          .current-score(v-if="current_step < questions.length") 当前分数
              span.score {{ current_score }}
          button.modal-toggler(data-toggle="modal" data-target="#result" v-else) 查看我的打分表
      #result.modal.fade(tabindex='-1' role='dialog' aria-hidden="true")
        .modal-dialog(role='document')
          .modal-content
            .modal-header.header
              .row
                .col
                    h2 我的打分表
                .col
                    .score 得分：{{ current_score }} 分
                button.close(type="button" data-dismiss="modal" aria-label="Close")
            .modal-body              
              section(v-for="question, key in questions" :key="key")
                Question(v-model="questions[key]" :index="key" @next="updateStep" :inline='true')
            .modal-footer.footer
              .row
                .col
                    .score 得分：{{ current_score }} 分
</template>

<script>
import Question from "./Question";
export default {
  components: {
    Question
  },
  props: ["questions", "min", "message", "error"],
  data() {
    return {
      current_step: 0
    };
  },
  computed: {
    current_score() {
      let sum = 0;
      for (const key in this.questions) {
        if (this.questions.hasOwnProperty(key)) {
          const question = this.questions[key];
          if (Number.isInteger(question.select)) {
            let score = question.options[question.select].score;
            sum += parseInt(score);
          }
        }
      }
      return sum;
    },
    current_progress() {
      let total = this.questions.length;
      return (this.current_step / total) * 100;
    }
  },
  methods: {
    updateStep(index) {
      this.current_step = index;
    },
    reset() {
      this.current_step = 0;
      this.$emit("reset", true);
    }
  }
};
</script>